import { usePreAnaliseLatest, useEmpresaServicos, useEventos } from '@/api/queries/empresa';
import { Skeleton } from '@/components/ui/skeleton';
import { Card } from '@/components/ui/card';

export function TabVisaoGeral({ empresaId }: { empresaId: string }) {
  const { data: pa } = usePreAnaliseLatest(empresaId);
  const { data: servicos } = useEmpresaServicos(empresaId);
  const { data: eventos } = useEventos(empresaId, 1);

  const firstEvento = eventos && eventos.items.length > 0 ? eventos.items[0] : null;

  return (
    <div className="grid gap-4 md:grid-cols-2 mt-4">
      <Card className="p-4">
        <h3 className="font-medium mb-2">Resumo</h3>
        {pa ? <p className="text-sm">{pa.resumo_uma_linha ?? '—'}</p> : <Skeleton className="h-12" />}
      </Card>
      <Card className="p-4">
        <h3 className="font-medium mb-2">Top 3 serviços</h3>
        {servicos ? (
          <ul className="text-sm space-y-1">
            {servicos.slice(0, 3).map((s) => (
              <li key={s.id}>
                <span className="font-medium">{s.servico.nome}</span>
                <span className="text-muted-foreground"> · fit {s.fit_score}</span>
              </li>
            ))}
            {servicos.length === 0 && (
              <li className="text-muted-foreground">Nenhum serviço fit.</li>
            )}
          </ul>
        ) : (
          <Skeleton className="h-24" />
        )}
      </Card>
      <Card className="p-4 md:col-span-2">
        <h3 className="font-medium mb-2">Último evento</h3>
        {firstEvento ? (
          <p className="text-sm">
            <span className="text-muted-foreground">
              {new Date(firstEvento.data_evento).toLocaleString('pt-BR')}
            </span>
            {' · '}
            {firstEvento.tipo} ({firstEvento.canal})
          </p>
        ) : (
          <p className="text-sm text-muted-foreground">Sem eventos.</p>
        )}
      </Card>
    </div>
  );
}
